import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MUITypography from '@material-ui/core/Typography';

function mapToThemeColors(colorName, theme) {
  const colorNameToThemeColorValue = {
    textPrimaryOnDark: theme.colors.text.primaryOnDark,
  };

  return colorNameToThemeColorValue[colorName];
}

function setColor(colorName, theme) {
  const customColour = mapToThemeColors(colorName, theme);
  if (customColour) {
    return customColour;
  }

  return theme.colors.text.primary;
}

const StyledTypography = styled(MUITypography)`
  color: ${props => setColor(props.color, props.theme)};

  &.MuiTypography-h1 {
    ${props => props.theme.typography.h1};
  }
  &.MuiTypography-h2 {
    ${props => props.theme.typography.h2};
  }
  &.MuiTypography-h3 {
    ${props => props.theme.typography.h3};
  }
  &.MuiTypography-h4 {
    ${props => props.theme.typography.h4};
  }
  &.MuiTypography-h5 {
    ${props => props.theme.typography.h5};
  }
  &.MuiTypography-h6 {
    ${props => props.theme.typography.h6};
  }

  &.MuiTypography-caption {
    ${props => props.theme.typography.caption};
  }

  &.MuiTypography-button {
    ${props => props.theme.typography.button};
  }

  &.MuiTypography-body1 {
    ${props => props.theme.typography.body1};
  }
  &.MuiTypography-body2 {
    ${props => props.theme.typography.body2};
  }

  &.MuiTypography-subtitle1 {
    ${props => props.theme.typography.subtitle1};
  }
  &.MuiTypography-subtitle2 {
    ${props => props.theme.typography.subtitle2};
  }

  &.MuiTypography-overline {
    ${props => props.theme.typography.overline};
  }

  &.MuiTypography-colorPrimary {
    color: ${props => props.theme.colors.brand.primary};
  }
  &.MuiTypography-colorSecondary {
    color: ${props => props.theme.colors.brand.secondary};
  }

  &.MuiTypography-colorTextPrimary {
    color: ${props => props.theme.colors.text.primary};
  }
  &.MuiTypography-colorTextSecondary {
    color: ${props => props.theme.colors.text.secondary};
  }
`;

const Typography = ({ children, ...rest }) => (
  <StyledTypography {...rest}>
    {children}
  </StyledTypography>
);

Typography.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Typography;
